<template>
    <div class="img-list">
        <div class="img-content" v-for="(item,key) in fileList" :key="key">
            <!-- <img :src="item.url"> -->
            <div class="name">
                <div>{{ item.name }}</div>
                <!-- <el-button type="info" size="mini" icon="el-icon-edit-outline" title="文件标签" circle @click="handleFileName(item,key)"></el-button>
                <el-button type="primary" size="mini" icon="el-icon-download" title="下载文件" circle @click="handleFileDownLoad(item,key)"></el-button> -->
            </div>
<!-- 删除icon -->
            <div class="del">
                <i @click="handleFileName(item,key)" title="文件标签" class="el-icon-edit-outline"></i>
                <i @click="handleFileDownLoad(item,key)" title="下载文件" class="el-icon-download"></i>
                <i @click="handleFileRemove(item,key)" title="删除文件" class="el-icon-delete"></i>
            </div>
            
<!-- 放大icon -->
            <!-- <div class="layer" @click="handleFileEnlarge(item.url)">
                <i class="el-icon-view"></i>
            </div> -->
        </div>
    </div>
</template>
<script>
export default{
    name: 'upload-list',
    data () {
        return {
            // fileList: [{
            //     url: 'http://img.hb.aicdn.com/723f8754f412debce188626d09cc0a1b2be6b7a6751a3-ICEp1E_fw658',
            //     name: 'lemon'
            // },{
            //     url: 'http://img.hb.aicdn.com/38ab9e558bcba041be979f03bfd31bd67bf1e6f35815a-8PD8Eo_fw658',
            //     name: 'lemon2'
            // },{
            //     url: 'http://img.hb.aicdn.com/0cd0dcc93f5b918e191dd84791101435136c7f9811e31-LRzYAQ_fw658',
            //     name: 'lemon3'
            // }]
        };
    },
    props: {
        fileList: { // 文件上传的类型。 task、process
            type: Array
        }
    },
    methods: {
        // handleFileEnlarge(_url){ // 放大图片
        //     console.log(_url)
        // },
        handleFileName (file, i) { // 修改名字
            // console.log(file,i)
        },
        handleFileRemove (file, i) { // 删除文件
            // console.log(file,i)
        },
        handleFileDownLoad (file, i) { // 下载文件
            // console.log(file,i)
        }
    }
};
</script>

<style lang="less">
  //  *{
  //       box-sizing: border-box;
  //   }
.img-list{
    overflow:hidden;
    width:100%;
}
.img-list .img-content{
    float:left;
    position:relative;
    display:inline-block;
    width:228px;
    // height:270px;
    padding:5px;
    // margin:5px 20px 20px 0;
    margin:3px 0px 0px 1px;
    border:1px solid #d1dbe5;
    border-radius:4px;
    transition:all .3s;
    box-shadow:0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);
}
.img-list .img-content img{
    display:block;
    width:100%;
    height:190px;
    margin:0 auto;
    border-radius:4px;
}
.img-list .img-content .name{
    // margin-top:10px;
}
.img-list .img-content .name>div{
    width:90%;
    text-overflow:ellipsis;
    overflow:hidden;
    // height:25px;
    // line-height:25px;
    font-size:12px;
}
.img-list .img-content:hover .del,
.img-list .img-content:hover .layer{
    opacity:1;
}
.img-list .img-content .del,
.img-list .img-content .layer{
    opacity:0;
    transition:all .3s;
}
.img-list .img-content .del{
    position:absolute;
    bottom:2px;
    right:10px;
    color:#8492a6;
    cursor:pointer;
    font-size:1.1em;
}
.img-list .img-content .layer{
    position:absolute;
    left:0;
    right:0;
    top:0;
    height:200px;
    color:#fff;
    text-align:center;
    z-index:5;
    background-color:rgba(0,0,0,.4);
}
.img-list .img-content .layer i{
    font-size:1.6em;
    margin-top:80px;
}
</style>


// WEBPACK FOOTER //
// src/components/FileList/FileList.vue